import SchoolIcon from "@mui/icons-material/School";
import ListSchoolSubjects from "./List";
import { SCHOOL_SUBJECTS, CandidateServicePath } from "utils/constants";
import EditSchoolSubjects from "./Edit";
import CreateSchoolSubjects from "./Create";
import permissions from "app/permissions";
import { tenants } from "utils/tenants";

//permissions
export const resources = {
  tenancies: [tenants.MU],
  isMenu: true,
  recordRepresentation: "nameBg",
  icon: <SchoolIcon />,
  name: CandidateServicePath + SCHOOL_SUBJECTS,
  title: "Училищни предмети",
  list: <ListSchoolSubjects />,
  create: <CreateSchoolSubjects />,
  createPermission: permissions.canCreateSchoolSubjects,
  edit: <EditSchoolSubjects />,
  editPermission: permissions.canUpdateSchoolSubjects,
  permission: permissions.canPreviewSchoolSubjects,
};
